<template>
    <div>
        <span v-if="job.length <= 0" class="text-muted p-3">No Pending</span>
        <template v-for="(row, i) in job">
            <b-card class="mb-3" body-class="py-3 px-4" style="cursor: pointer" :key="i" @click="selectJob(row,i)" v-if="selectMail !=row._id">
                <div class="row justify-content-between">
                  <div class="col-6 px-1" v-if="row.status !='New Mail'">
                      <h6 class="text-primary">{{row.tracking_id}}</h6>
                  </div>
                  <div class="col-6 px-1" v-else>
                    <h6 class="text-primary">{{ row.tracking_id }}</h6>
                    <div>Draft E-mail</div>
                  </div>
                  <div class="col-auto pr-1">
                    <b-button
                      size="sm"
                      class="btn-gradient-success w-100 py-1 px-2 d-flex align-item-center justify-content-between border-0"
                      :class="
                        row.status == 'In Process'
                          ? 'btn-gradient-primary'
                          : 'btn-gradient-pink'
                      "
                      >{{ row.status }}

                      <i
                        style="font-size: 1.1rem"
                        class="icofont"
                        :class="
                          row.status == 'In Process'
                            ? 'icofont-check-circled'
                            : 'icofont-clock-time'
                        "
                      ></i
                    ></b-button>
                  </div>
                  <p class="col-12 px-1 text-muted">
                    {{row.subject}}
                  </p>
                </div>
            </b-card>
        </template>
    </div>
</template>

<script>
  import { requestService } from './../../_services';
  import template from './template.vue';
  export default {
      components: { template },
      data() {
          return {
              job: [],
              selectMail:""
          };
      },
      async mounted() {
        const self = this;
        this.$root.$on('setAgentDesktopJob', (data) => {
            self.job = data;
        });
        this.$root.$on('setSelectMail', (id) => {
            self.selectMail = id;
        });
        this.$root.$on('getCountPending', (id) => {
            let filtered = this.job.filter((x) =>{
              if(x.status =='Pending'){
                  return x
              }
            });
            if(filtered.length >=2){
              this.$swal.fire({
                icon: 'error',
                text: 'ไม่สามารถรับ E-mail ได้เนื่องจาก E-mail ที่คุณได้รับเกินกำหนด',
              });
              return;
            }else{
                this.$root.$emit('updateStatus', "ready");
                this.$root.$data.WorkerIO.port.postMessage(['changeStatus', "ready"]);
            }
        });
      },
      beforeDestroy(){
          this.$root.$off('setAgentDesktopJob', null)
          this.$root.$off('setSelectMail', null)
          this.$root.$off('getCountPending', null)
      },
      methods: {
          selectJob(row,index){
              if(this.selectMail !=""){
                this.$swal.fire({
                      icon: 'error',
                      title: 'Try Again',
                      text: 'Close or Hold Job Now!',
                  });
                  return
              }
              let self = this;
              let obj = {};
              obj['mail_id'] = row._id;
              self.selectMail= row._id;
              let url = `/api/desktop/inprocess/${row._id}/job`;
                  let object={}
                  requestService.PostFetch('ccp', url, object).then((response) => {
                      self.$root.$emit('reloadPendingJob');
                      self.$root.$emit('notificationToAgent', obj);
                      self.$root.$emit('setAgentDesktopTab', 1);
                      self.$root.$data.WorkerIO.port.postMessage(['changeStatus', 'acd']);
                  }).catch((err) => {
                      this.$swal.fire({
                          icon: 'error',
                          title: 'Try Again',
                          text: err,
                      });
                  });
              // if(row.status !="New Mail"){
              //     let url = `/api/desktop/inprocess/${row._id}/job`;
              //     let object={}
              //     requestService.PostFetch('ccp', url, object).then((response) => {
              //         self.$root.$emit('reloadPendingJob');
              //         self.$root.$emit('notificationToAgent', obj);
              //         self.$root.$emit('setAgentDesktopTab', 1);
              //         self.$root.$data.WorkerIO.port.postMessage(['changeStatus', 'acd']);
              //     }).catch((err) => {
              //         this.$swal.fire({
              //             icon: 'error',
              //             title: 'Try Again',
              //             text: err,
              //         });
              //     });
              // }else{
              //     self.$root.$emit('reloadPendingJob');
              //     self.$root.$emit('notificationToAgent', obj);
              //     self.$root.$emit('setAgentDesktopTab', 1);
              //     self.$root.$data.WorkerIO.port.postMessage(['changeStatus', 'acd']);
              // }
          },
      },
  };
</script>

<style lang="scss">
  // .fade-enter-active,
  // .fade-leave-active {
  //   & > * {
  //     transition-duration: 200ms;
  //     transition-property: opacity, transform;
  //     transition-timing-function: cubic-bezier(0.6, 0.15, 0.35, 0.8);
  //   }
  // }

  // $delay: 100ms;
  // $delayStep: 100ms;

  // .fade-enter,
  // .fade-leave-to {
  //   & > * {
  //     opacity: 0;
  //     transform: translateY(40px);
  //   }
  // }
  // .fade-enter-active {
  //   & > * {
  //     &:nth-child(1) {
  //       transition-delay: $delay;
  //     }
  //     &:nth-child(2) {
  //       transition-delay: $delay + $delayStep;
  //     }
  //   }
  // }
  // .fade-leave-active {
  //   & > * {
  //     &:nth-child(1) {
  //       transition-delay: $delay + $delayStep;
  //     }
  //     &:nth-child(2) {
  //       transition-delay: $delay;
  //     }
  //   }
  // }
</style>
